import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** Every borrower industry, alphabetical: the ONE list behind every Borrower Industry filter on the Portfolio Performance pages.
 *  The server makes it from the distinct sic_division values of athena_bfsi_rbp.prepayment_charts, without that table's
 *  "All Industries" roll-up row, so each page adds its own "All ..." option in front of it. Empty until it loads. */
export function useBorrowerIndustries() {
  return useQuery({
    queryKey: ["borrower-industries"] as const,
    queryFn: () => apiGet<string[]>("/borrower-industries"),
    staleTime: 10 * 60_000,
  });
}
